import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";
import { useSelector } from "react-redux";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  const userDetails = useSelector((state) => state.Profile.userDetails);

  // console.log("userProfileSession", userProfileSession);
  var token = userProfileSession && userProfileSession["access"];

  const [loading, setLoading] = useState(userProfileSession ? false : true);

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token = userProfileSession && userProfileSession["access"];

    setLoading(token ? false : true);
  }, []);

  // console.log("userDetails", userDetails);

  return { userDetails, loading, token };
};

export { useProfile };
